import styled from "styled-components"
import { CenterMiddle } from "../../global-styles/mixins"

export const Container = styled.div`
    ${CenterMiddle}
    padding: 1rem;
    border-radius: 0.5rem;
    text-align: center;
    color: var(--white);
    background-color: var(--red);
`